import * as http from 'reporting-data/request/http';
import { isImmutableJourneyReport } from 'reporting-snowflake/funnel/types/journeyReport';
const INSIGHTS_FETCH_URL = 'reporting-insights/copilot/v1/generate';
const SEARCH_REPORT_INSIGHTS_FETCH_URL = 'reporting-insights/copilot/v1/generate/single-object-search';
const JOURNEY_REPORT_INSIGHTS_FETCH_URL = 'reporting-insights/copilot/v1/generate/journey-testing';
const getJourneyReportInsightsApi = ({
  param,
  options = {
    ttl: 30000,
    numberOfInsights: 3
  }
}) => {
  return http.post(`${JOURNEY_REPORT_INSIGHTS_FETCH_URL}?numberOfInsights=${options.numberOfInsights}`, param, {
    ttl: options.ttl
  });
};
const getGeneralReportInsightsApi = ({
  param,
  options = {
    ttl: 30000,
    numberOfInsights: 3
  }
}) => {
  return http.post(`${INSIGHTS_FETCH_URL}?numberOfInsights=${options.numberOfInsights}`, param, {
    ttl: options.ttl
  });
};
export const getSearchReportInsightsApi = ({
  param,
  options = {
    ttl: 30000,
    numberOfInsights: 3
  }
}) => {
  return http.post(`${SEARCH_REPORT_INSIGHTS_FETCH_URL}?numberOfInsights=${options.numberOfInsights}`, param, {
    ttl: options.ttl
  });
};
export const getNonSearchReportInsightsApi = ({
  param,
  options = {
    ttl: 30000,
    numberOfInsights: 3
  },
  report
}) => {
  if (isImmutableJourneyReport(report)) {
    return getJourneyReportInsightsApi({
      param,
      options: {
        numberOfInsights: options.numberOfInsights,
        ttl: options.ttl
      }
    });
  }
  return getGeneralReportInsightsApi({
    param,
    options: {
      numberOfInsights: options.numberOfInsights,
      ttl: options.ttl
    }
  });
};